document.addEventListener('DOMContentLoaded', function(){
  const menuButton = document.querySelector('[data-nnf-menu]');
  const nav = document.querySelector('[data-nnf-nav]');
  if(menuButton && nav){
    menuButton.addEventListener('click', function(){
      const open = nav.classList.toggle('nnf-nav--open');
      menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuButton.textContent = open ? 'CLOSE' : 'MENU';
      if(open){
        nav.style.display='flex'; nav.style.position='absolute'; nav.style.left='14px'; nav.style.right='14px'; nav.style.top='72px'; nav.style.padding='20px'; nav.style.background='#fff'; nav.style.border='1px solid #dfe4e8'; nav.style.borderRadius='16px'; nav.style.flexDirection='column'; nav.style.alignItems='flex-start'; nav.style.boxShadow='0 22px 55px rgba(12,18,24,.12)';
      } else { nav.removeAttribute('style'); }
    });
    nav.querySelectorAll('a').forEach(function(link){link.addEventListener('click',function(){if(nav.classList.contains('nnf-nav--open')) menuButton.click();});});
  }

  // The homepage template can be used before product pickers are configured. Keep its primary bundle CTA useful either way.
  document.querySelectorAll('a').forEach(function(link){
    if(link.textContent.trim().toLowerCase()==='shop the complete system'){
      link.setAttribute('href','/products/nope-no-fur™-7-piece-pet-hair-removal-and-grooming-system');
    }
  });

  // When an anchor exists on the homepage but the visitor is on a product/page route, send them back to the homepage anchor.
  document.querySelectorAll('a[href^="#"]').forEach(function(link){
    if(location.pathname !== '/') link.setAttribute('href','/' + link.getAttribute('href'));
  });
});

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-nnf-gallery]').forEach(function(gallery){
    const main = gallery.querySelector('[data-nnf-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-nnf-gallery-thumb]'));
    const prev = gallery.querySelector('[data-nnf-gallery-prev]');
    const next = gallery.querySelector('[data-nnf-gallery-next]');
    const currentLabel = gallery.querySelector('[data-nnf-gallery-current]');
    if(!main || !thumbs.length) return;
    let current = 0;
    function show(index){
      current=(index+thumbs.length)%thumbs.length;
      const thumb=thumbs[current]; main.src=thumb.dataset.imageUrl; main.alt=thumb.dataset.imageAlt||'';
      thumbs.forEach(function(item,i){const active=i===current;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',active?'true':'false');});
      if(currentLabel) currentLabel.textContent=String(current+1);
    }
    thumbs.forEach(function(thumb,index){thumb.addEventListener('click',function(){show(index);});});
    if(prev) prev.addEventListener('click',function(){show(current-1);});
    if(next) next.addEventListener('click',function(){show(current+1);});
    let startX=null;
    main.addEventListener('touchstart',function(e){startX=e.touches[0].clientX;},{passive:true});
    main.addEventListener('touchend',function(e){if(startX===null)return;const delta=e.changedTouches[0].clientX-startX;if(Math.abs(delta)>45)show(delta<0?current+1:current-1);startX=null;},{passive:true});
  });
});
